import * as Sentry from "@sentry/react";

const sentryEnvironment = () => {
  const env = process.env.NEXT_PUBLIC_DEPLOYMENT_ENVIRONMENT || "developer";
  switch (env) {
    case "prod":
      return "production";
    case "dev":
      return "development";
    default:
      return env;
  }
};

Sentry.init({
  dsn: "https://7f22939566d18c7d52d22c8808a7f456@o4506152281374720.ingest.us.sentry.io/4506157510295552",
  enableLogs: true,
  integrations: [Sentry.consoleLoggingIntegration()],
  environment: sentryEnvironment(),
  enabled: process.env.NEXT_PUBLIC_SENTRY_ENABLED === "1",
});
